import { injectIntl } from 'react-intl';

import SuggestionItem from './SuggestionItem';

export default injectIntl(SuggestionItem);
